module.exports = __webpack_public_path__ + "img/meiye1.565a2617.png";